


import SECTION_VIPBANNERSECTION from
'../dynamic_section/dynamic_2/template_01';





import SECTION_VIPCONTENTSECTION from
'../dynamic_section/dynamic_2/template_01';





import SECTION_VIPCONTENTMSECTION from
'../dynamic_section/dynamic_2/template_01';






import VIPSection from '../sections/vip/default';






import SECTION_FOOTER_BANNER from
'../dynamic_section/dynamic_2/template_01';



import "./style.css";


const VipPage = ()=>{
return (
  <div id="vipPage" class="page bg_global">
  
  

  
  < SECTION_VIPBANNERSECTION desktopToggle={ true }
    mobileToggle={ true } label={ `vip banner` } id={ `vip_banner` } supportLanguage={
    true } titleToggle={ false } titleIconToggle={
    true } linkTo={ `` } addContainer={ false } />
  
  
  
  

  
  < SECTION_VIPCONTENTSECTION desktopToggle={ true }
    mobileToggle={ false } label={ `vip content` } id={ `vip_content` } supportLanguage={
    true } titleToggle={ false } titleIconToggle={
    true } linkTo={ `` } addContainer={ false } />
  
  
  
  

  
  < SECTION_VIPCONTENTMSECTION desktopToggle={ false }
    mobileToggle={ true } label={ `vip content_m` } id={ `vip_content_m` } supportLanguage={
    true } titleToggle={ false } titleIconToggle={
    true } linkTo={ `` } addContainer={ false } />
  
  
  
  

  
  <VIPSection desktopToggle={ false } mobileToggle={
    false } mobileBannerToggle={ false } desktopBannerToggle={
    false } mode={``} aboutUsToggle={ true }
    faqToggle={ true } tncToggle={ true } benefitToggle={
    true } reviewToggle={ true } />
  
  
  
  

  
  < SECTION_FOOTER_BANNER desktopToggle={ true }
    mobileToggle={ false } label={ `Dynamic Section2` } id={ `footer_banner` } supportLanguage={
    true } titleToggle={ false } titleIconToggle={
    true } linkTo={ `` } addContainer={ false } />
  
  
  
</div>
)
}

export default VipPage;